/**
 * @generated SignedSource<<04ef1871bac4b73aed69407242f67a8b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarFavorites_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item" | "FavoritesProvider_item">;
  readonly " $fragmentType": "PdpSharedSidebarFavorites_item";
};
export type PdpSharedSidebarFavorites_item$key = {
  readonly " $data"?: PdpSharedSidebarFavorites_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarFavorites_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesProvider_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "49177b3b94dceaca3e3eaefb4bbadf26";

export default node;
